import { createContext, Dispatch, SetStateAction } from 'react';

export type CachedPublicTenderDetails = {
  tenderShareId?: string;
};

export type StoredPublicTender = {
  tenderShareId: string;
  title?: string;
  description?: string;
  active_until?: number;
  deadline_at?: number;
  global_serial?: string;
};

export interface CachedPublicTenderCtx {
  currentCachedPublicTender: CachedPublicTenderDetails | null;
  setCurrentCachedPublicTender: Dispatch<
    SetStateAction<CachedPublicTenderCtx['currentCachedPublicTender']>
  >;
  cachedPublicTendersContext: StoredPublicTender[];
  setCachedPublicTendersContext: Dispatch<
    SetStateAction<CachedPublicTenderCtx['cachedPublicTendersContext']>
  >;
}

const CachedPublicTenderContext = createContext({
  currentCachedPublicTender: null,
  setCurrentCachedPublicTender: () => ({}),
  cachedPublicTendersContext: [],
  setCachedPublicTendersContext: () => [],
} as CachedPublicTenderCtx);

export default CachedPublicTenderContext;
